import axios  from "axios"

export default {
    async getDropdownData(data){
        return await axios.post('/option', data)
        .then(({data}) => data)
        .catch(error => {return Promise.reject(error.response); });
    },

    getDashboardStatistics() {
        return axios.get('/dashboard/statistics')
        .then(({data}) => Promise.resolve(data))
        .catch(err => Promise.reject(err.response))
    }

}